import { Menu, MoreHorizontal, Share2, Trash2 } from 'lucide-react';
import type { ModelOption } from '../types/chat';
import { ModelSelector } from './ModelSelector';

type TopBarProps = {
  title: string;
  models: ModelOption[];
  selected: ModelOption | null;
  selectedAlias: string;
  modelLoading: boolean;
  modelError: string;
  hasMessages: boolean;
  desktopSidebarOpen: boolean;
  onOpenMenu: () => void;
  onSelectModel: (alias: string) => void;
  onShare: () => void;
  onReset: () => void;
};

export function TopBar(props: TopBarProps) {
  return (
    <header className="flex h-14 shrink-0 items-center border-b border-border px-3 md:h-[60px] md:px-5 lg:h-16 lg:px-6">
      <button type="button" onClick={props.onOpenMenu} className={`icon-button mr-2 ${props.desktopSidebarOpen ? 'lg:!hidden' : 'lg:!grid'}`} aria-label="Buka menu">
        <Menu className="size-5" />
      </button>
      <h1 className="min-w-0 flex-1 truncate text-center text-sm font-semibold text-primary lg:text-left lg:text-base">
        <span className="lg:hidden">Multi-Model AI</span>
        <span className="hidden lg:inline">{props.title}</span>
      </h1>
      <div className="ml-3 flex items-center gap-2">
        <ModelSelector
          models={props.models}
          selected={props.selected}
          selectedAlias={props.selectedAlias}
          loading={props.modelLoading}
          error={props.modelError}
          onSelect={props.onSelectModel}
        />
        {props.hasMessages && (
          <>
            <button type="button" onClick={props.onShare} className="interactive hidden h-9 items-center gap-2 rounded-lg px-3 text-sm text-secondary hover:bg-surface-hover hover:text-primary sm:flex">
              <Share2 className="size-4" />Bagikan
            </button>
            <button type="button" onClick={props.onReset} className="icon-button !hidden text-danger hover:bg-danger/10 sm:!grid" aria-label="Hapus percakapan">
              <Trash2 className="size-4" />
            </button>
          </>
        )}
        <button type="button" className="icon-button !hidden sm:!grid" aria-label="Opsi lainnya">
          <MoreHorizontal className="size-5" />
        </button>
      </div>
    </header>
  );
}
